export const toOrdinal = number => {
  const lastDigit = number % 10;
  const secondLastDigit = Math.floor((number % 100) / 10);

  if (secondLastDigit === 1) {
    return `${number}th`;
  }

  switch (lastDigit) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
};
